import React, { useCallback, useMemo } from 'react';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';

import styles from '../styles';
import CustomIconButton from '../../../partials/tableCustomButtons/CustomIconButton';
import { deleteConnectRange } from '../actions/deleteConnectRange';
import DeleteRangeConfimation from './DeleteRangeConfimation';
import ConfirmDialog from '../../../partials/confirmationDialog/ConfirmDialog';
import { isDefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';

const ConnectActionButtons = ({
  numberRange,
  classes,
  connectClientId,
  client,
  deleteConnectRange
}) => {
  const resetValues = useMemo(() => {
    return {
      id: client,
      getServiceOperator: false,
      getConnectRanges: true,
      connectClientId
    };
  }, [client, connectClientId]);

  const deletable = useMemo(() => {
    const our = Optional(numberRange?.all)
      .map(
        numbers =>
          numbers.filter(number => isDefined(number.founded)).length > 0
      )
      .or(false);

    const hasAssignedNumbers = Optional(numberRange?.assigned)
      .map(numbers => numbers.length > 0)
      .or(false);

    return !our && !hasAssignedNumbers;
  }, [numberRange]);

  const onDeleteClick = useCallback(
    () => deleteConnectRange({ numberRange, resetValues }),

    // eslint-disable-next-line
    [numberRange]
  );

  return (
    <div className={classes.actionButtons}>
      <div>
        <ConfirmDialog
          onConfirmClick={onDeleteClick}
          dialogContentComponent={<DeleteRangeConfimation />}
          dialogTitleIntlId={'TOOLTIP.DELETE_RANGE'}
        >
          <CustomIconButton
            iconTooltipIntlKey="TOOLTIP.DELETE_RANGE"
            iconClassName="far fa-trash-alt"
            disabled={!deletable}
          />
        </ConfirmDialog>
      </div>
    </div>
  );
};

const mapStatesToProps = ({ selectClient }) => {
  return {
    connectClientId: selectClient.selectedClient.connect30_domain,
    client: selectClient.selectedClient.id
  };
};

const mapDispatchToProps = {
  deleteConnectRange
};

export default flowRight(
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(ConnectActionButtons);
